document.addEventListener('DOMContentLoaded', () => {
	let qaPairs = document.querySelectorAll('.qa-pair')

	qaPairs.forEach(pair => {
		pair.querySelector('h3')?.addEventListener('click', () => {
			pair.classList.toggle('expanded')
		})
	})

	const calcHeights = () => {
		qaPairs.forEach(pair => {
			let answer = pair.querySelector('.answer')

			answer?.setAttribute('style', `--expanded-height: auto;`) // This part is necessary to actually recalculate the tallest .visible element on window resize

			answer?.setAttribute(
				'style',
				`--expanded-height: ${answer.scrollHeight}px;`
			)
		})
	}

	calcHeights()

	window.addEventListener('resize', calcHeights)
})
